/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ReuseDayResultDtoBase
 * auto generated base class for the model ReuseDayResultDtoModel.
 */
export const ReuseDayResultDtoModelBase = ModelBase
  .named('ReuseDayResultDto')
  .props({
    __typename: types.optional(types.literal("ReuseDayResultDto"), "ReuseDayResultDto"),
    routeUuids: types.union(types.undefined, types.array(types.identifier)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ReuseDayResultDtoModelSelector extends QueryBuilder {
  get routeUuids() { return this.__attr(`routeUuids`) }
}
export function selectFromReuseDayResultDto() {
  return new ReuseDayResultDtoModelSelector()
}

export const reuseDayResultDtoModelPrimitives = selectFromReuseDayResultDto().routeUuids
